import type { StatusChipProps } from '@components/v2/ui/StatusChip/StatusChip';
import {
  AbandonedDot,
  ApprovedDot,
  CanceledDot,
  DraftDot,
  InApprovalDot,
  InReviewDot,
  OfflineDot,
  RejectedDot,
  SentDot,
} from '@components/v2/ui/StatusChip/components/statusIcon.icons';
import { RefreshCcw, Star } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { OfflineStatus } from '../../../offline/domain/offlineOrder/offlineOrder.types';
import { OrderStatus } from '../../interfaces/order-status.interface';
import { VirtualOrderStatus } from '../../order.types';

export const ORDER_STATUS_CHIP_CONFIG: Record<OrderStatus, Omit<StatusChipProps, 'size'>> = {
  DRAFT: { label: LangEnum.ORDER_STATUS_DRAFT, icon: DraftDot, color: 'neutral' },
  SUGGESTED: { label: LangEnum.ORDER_STATUS_SUGGESTED, icon: Star, color: 'closed' },
  IN_REVISION: { label: LangEnum.ORDER_STATUS_IN_REVISION, icon: InReviewDot, color: 'waiting' },
  ON_APPROVAL: { label: LangEnum.ORDER_STATUS_ON_APPROVAL, icon: InApprovalDot, color: 'progress' },
  APPROVED: { label: LangEnum.ORDER_STATUS_APPROVED, icon: ApprovedDot, color: 'success' },
  SENT: { label: LangEnum.ORDER_STATUS_SENT, icon: SentDot, color: 'successStrong' },
  CANCELED: { label: LangEnum.ORDER_STATUS_CANCELED, icon: CanceledDot, color: 'closed' },
  REJECTED: { label: LangEnum.ORDER_STATUS_REJECTED, icon: RejectedDot, color: 'closed' },
  ABANDONED: { label: LangEnum.ORDER_STATUS_ABANDONED, icon: AbandonedDot, color: 'inactive' },
};

export const ORDER_LIST_STATUS_CHIP_CONFIG: Record<
  OrderStatus | OfflineStatus | VirtualOrderStatus,
  Omit<StatusChipProps, 'size'>
> = {
  ...ORDER_STATUS_CHIP_CONFIG,
  [OfflineStatus.OFFLINE]: { label: LangEnum.GLOBAL_OFFLINE, icon: OfflineDot, color: 'neutral' },
  [OfflineStatus.SYNCING]: { label: LangEnum.GLOBAL_SYNCING, icon: RefreshCcw, color: 'progress' },
  [OfflineStatus.ERROR_SYNCING]: { label: LangEnum.GLOBAL_ERROR, icon: RefreshCcw, color: 'error' },
  [VirtualOrderStatus.MASS_ACTION_STATUS_UPDATING]: {
    label: LangEnum.GLOBAL_UPDATING,
    icon: RefreshCcw,
    color: 'progress',
  },
};
